import styled from 'styled-components';

const Wrapper = styled.section`
margin-top: 5rem;
text-align: center;
padding: var(--size-4xl);
strong:hover{
    color: var(--clr-green);
    transition: color 0.4s;
}
`

export default Wrapper;